import React from "react";
import { Icon, Text, TooltipWrapper, Pill, PillWrapper } from "@theorgchartdev/storybook";
import { gUpgradeIndicatorIcon } from "@coreapp/whitelabel/brand";
import { appstr } from "@coreapp/utils/appstr";
import cx from "classnames";

export const CardButton = ({
  title,
  description = "Lorem ipsum",
  icon,
  isSelected = false,
  onClick,
  disabled,
  tooltipProps,
  upgradeIcon = false,
  pillTestId = "upgrade-pill",
  dataTestId
}) => {
  let pillElement = (
    <PillWrapper
      style={{
        display: "inline-block",
        position: "relative",
        cursor: "pointer",
        paddingLeft: "10px"
      }}
    >
      <span style={{ width: "100%" }}>
        <Pill
          className={cx("oc-relative", "oc-fit-content")}
          dataTestId={pillTestId}
          label={appstr("Upgrade")}
          color="brand"
          leftContent={
            <Icon
              name={gUpgradeIndicatorIcon}
              size="xsmall"
              modifier="primary"
              dataTestId={`${pillTestId}-icon`}
            />
          }
        />
      </span>
    </PillWrapper>
  );

  const content = (
    <div
      className={`card-button ${isSelected ? "card-button--selected" : ""} ${disabled ? "card-button--disabled" : ""}`}
      onClick={disabled ? undefined : onClick}
      role="button"
      aria-pressed={isSelected}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      data-testid={dataTestId}
      onKeyDown={e => {
        if (!disabled && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          e.currentTarget.click();
        }
      }}
    >
      <div className="card-button--header">
        <Text size={"medium"} modifier={"bold"}>
          {title}
        </Text>
        {icon && <Icon name={icon} size={"medium"} />}
        {upgradeIcon && pillElement}
      </div>
      <Text size={"small"}>{description}</Text>
    </div>
  );

  return <div>{content}</div>;
};
